import { apiFetch } from '@/api/client'

export const authApi = {
  login: (form) => apiFetch('login', { method: 'POST', body: form }),
  register: (payload) => apiFetch('register', { method: 'POST', body: payload }),
  signup: (payload) => apiFetch('signup', { method: 'POST', body: payload }),
  profile: (params) => apiFetch('profile', { params }),
  // multipart: FormData payload; the client drops any hand-written Content-Type.
  updateProfile: (userId, payload) =>
    apiFetch(`profile/${userId}`, {
      method: 'POST',
      body: payload,
      headers: { 'Content-Type': 'multipart/form-data' },
    }),

  googleRedirect: () => apiFetch('auth/google'),
  googleCallback: (params) => apiFetch('auth/google/callback', { params }),

  resendVerification: (payload) => apiFetch('email/resend', { method: 'POST', body: payload }),
  verifyEmail: (payload) => apiFetch('email/verify', { method: 'POST', body: payload }),
  forgotPassword: (payload) => apiFetch('forgot-password', { method: 'POST', body: payload }),
  resetPassword: (payload) => apiFetch('reset-password', { method: 'POST', body: payload }),
  verifyResetPasswordToken: (payload) =>
    apiFetch('reset-password-verify', { method: 'POST', body: payload }),
}
